


















import { IGuest } from "@/@types/admin/guest/user";
import { Component, Prop, Vue } from "vue-property-decorator";

import InputSearch from "@/components/app/search/input-search.vue";
import ShortGuestCard from "./short-guest-card.vue";

@Component({
  components: { InputSearch, ShortGuestCard },
})
export default class LightGuestList extends Vue {
  @Prop({ type: Array, default: () => [] }) guestList!: Array<IGuest>;

  search = "";

  get guests(): Array<IGuest> {
    let list: Array<IGuest> = [];
    list = this.guestList.filter((item: IGuest) => {
      if (item.personal_data)
        return (
          item.personal_data.surname
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
    });
    if (!list.length)
      list = this.guestList.filter((item: IGuest) => {
        return (
          item.personal_data.first_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
      });
    return list;
  }
}
